import {NgOptimizedImage} from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {MatBadge} from "@angular/material/badge";
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatToolbar} from '@angular/material/toolbar';
import {MatTooltip} from '@angular/material/tooltip';
import {Router, RouterLink} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {NotificationStore} from "../state/notification.store";
import {UserStore} from '../state/user.store';
import {environment} from "../../environments/environment";

@Component({
  selector: 'euroports-header',
  imports: [
    MatIcon,
    MatIconButton,
    MatToolbar,
    MatTooltip,
    TranslateModule,
    NgOptimizedImage,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    RouterLink,
    MatBadge
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private userStore = inject(UserStore);
  private notificationStore = inject(NotificationStore);
  private oauthService = inject(OAuthService);
  public translate = inject(TranslateService);
  public router = inject(Router);

  isAdmin = this.userStore.isAdmin;
  isAccountant = this.userStore.isAccountant;
  isBuyer = this.userStore.isBuyer;
  username = computed(() => {
    const user = this.userStore.currentUser();
    if (!user) return '';
    return `${user.firstName} ${user.lastName}`;
  });
  notificationsCount = this.notificationStore.count;

  protected displayBanner = environment.display_banner ?? false;
  protected envBannerCollapsed = false;

  constructor() {
    this.notificationStore.loadNotificationsCount();
  }

  useLanguage(language: string): void {
    this.translate.use(language);
  }

  logOut(): void {
    this.oauthService.logOut();
  }

  toggleBanner() {
    this.envBannerCollapsed = !this.envBannerCollapsed;
  }
}
